export default {
  'material.info': 'My Info',
  'material.collect': 'My Collection',
  'material.create': 'My Creation',
  'material.unbind': 'Unbind',
};
